export interface NewsItem {
  id: number;
  title: string;
  category: '作品动态' | '活动资讯' | '媒体专访' | '生活花絮';
  date: string;
  views: number;
  thumbnail: string;
  summary: string;
  content: string;
}

export const news: NewsItem[] = [
  {
    id: 1,
    title: '小仓优子新作《星夜之约》杀青，奇幻爱情题材引期待',
    category: '作品动态',
    date: '2026-09-28',
    views: 18420,
    thumbnail: 'https://readdy.ai/api/search-image?query=cinematic%20behind%20the%20scenes%20photo%20of%20an%20elegant%20young%20East%20Asian%20actress%20on%20a%20hilltop%20film%20set%20at%20night%20surrounded%20by%20crew%20and%20warm%20starlight%20glow%2C%20deep%20wine%20red%20and%20golden%20color%20tone%2C%20documentary%20photography%20style%2C%20high%20detail&width=800&height=500&seq=ogura-news-01&orientation=landscape',
    summary: '历时三个月的拍摄后，小仓优子主演的奇幻爱情电影《星夜之约》正式杀青，影片预计将于明年春季与观众见面。',
    content: '历经近三个月的紧张拍摄，小仓优子主演的奇幻爱情电影《星夜之约》于近日正式宣布杀青。剧组在社交平台上发布了主创团队的合影，画面中全体工作人员笑容满满，小仓优子手捧鲜花向剧组致谢。\n\n据片方透露，影片以“星夜重逢”为核心设定，讲述女主角在特定夜晚能够回到过去、与重要之人再次相遇的故事。小仓优子在片中挑战了时间跨度的多层次表演，从青涩少女到成熟女性，情绪变化复杂而细腻。\n\n导演山田健一在采访中表示，小仓优子为这个角色投入了大量精力，不仅反复推敲人物心理，还主动参与了多场关键戏份的沟通与调整。他评价道：“她把角色内心最柔软的部分演活了。”\n\n影片目前进入后期制作阶段，预计将于明年春季正式上映，具体档期有待片方进一步公布。',
  },
  {
    id: 2,
    title: '小仓优子亮相国际电影节红毯，深酒红礼服成全场焦点',
    category: '活动资讯',
    date: '2026-09-15',
    views: 23150,
    thumbnail: 'https://readdy.ai/api/search-image?query=cinematic%20red%20carpet%20event%20photo%20of%20an%20elegant%20young%20East%20Asian%20actress%20in%20a%20deep%20wine%20red%20evening%20gown%20posing%20under%20warm%20event%20lights%20with%20photographers%20blurred%20behind%2C%20glamorous%20atmosphere%2C%20golden%20highlights%2C%20high%20detail&width=800&height=500&seq=ogura-news-02&orientation=landscape',
    summary: '小仓优子受邀出席国际电影节开幕红毯，一袭深酒红礼服优雅登场，成为当晚媒体镜头的焦点之一。',
    content: '近日，小仓优子受邀出席某国际电影节的开幕红毯。当晚，她以一袭深酒红色高定礼服亮相，搭配简约珠宝与利落盘发，兼具大气与优雅，迅速成为全场媒体的焦点。\n\n红毯上，小仓优子与影迷亲切互动，并耐心回答了媒体的简短提问。谈及此次参展，她表示能够带着作品来到国际舞台十分荣幸，也期待未来能有更多不同类型的角色与观众见面。\n\n据现场工作人员介绍，小仓优子提前数小时便到场准备，全程状态从容。多位时尚媒体对她的造型给出了高度评价，认为这套礼服完美呼应了电影节的高级质感。\n\n当晚的活动结束后，小仓优子在社交平台发布动态感谢主办方与影迷的支持，短短数小时便收获大量点赞与留言。',
  },
  {
    id: 3,
    title: '专访小仓优子：演员这条路，我还在慢慢走',
    category: '媒体专访',
    date: '2026-08-30',
    views: 19870,
    thumbnail: 'https://readdy.ai/api/search-image?query=warm%20editorial%20portrait%20of%20an%20elegant%20young%20East%20Asian%20actress%20sitting%20in%20a%20cozy%20sunlit%20cafe%20during%20an%20interview%2C%20soft%20natural%20light%2C%20cream%20and%20wine%20red%20tone%2C%20magazine%20interview%20photography%2C%20high%20detail&width=800&height=500&seq=ogura-news-03&orientation=landscape',
    summary: '在一次深度专访中，小仓优子回顾了自己的演艺历程，并分享了对表演、成长与未来的真诚想法。',
    content: '在一间安静的咖啡馆里，小仓优子接受了我们的深度专访。素颜淡妆的她比荧幕上更显亲和，谈起表演时眼神却格外认真。\n\n回顾入行以来的历程，小仓优子坦言曾有过迷茫的时刻。“刚开始的时候，我总想证明自己，反而用力过猛，”她说，“后来才慢慢明白，表演不是表演给别人看，而是先要相信那个角色真的活着。”\n\n谈及近年来在悬疑、家庭、爱情等不同题材中的尝试，她表示希望不断跳出舒适区。“每一位演员都会有自己的定型，但我想做的是让观众记住角色，而不是记住某种固定的我。”\n\n当被问到对未来的期待，小仓优子笑言自己“还在慢慢走”。“我不急着到达某个终点，只想每一步都走得踏实。”这句朴素的回答，或许正是她一路走来的写照。',
  },
  {
    id: 4,
    title: '《沉默的证人》口碑发酵，小仓优子法医造型获好评',
    category: '作品动态',
    date: '2026-08-18',
    views: 16240,
    thumbnail: 'https://readdy.ai/api/search-image?query=cinematic%20still%20of%20an%20elegant%20young%20East%20Asian%20actress%20as%20a%20forensic%20doctor%20in%20a%20modern%20lab%20examining%20evidence%20under%20cool%20lighting%20with%20warm%20accents%2C%20wine%20red%20and%20slate%20color%20tone%2C%20prestige%20drama%20photography%2C%20high%20detail&width=800&height=500&seq=ogura-news-04&orientation=landscape',
    summary: '刑侦剧《沉默的证人》播出后口碑持续走高，小仓优子饰演的女法医造型专业、表演冷静，成为讨论热点。',
    content: '随着剧情的推进，刑侦悬疑剧《沉默的证人》口碑持续发酵。小仓优子在剧中饰演女法医青山遥，其专业干练的造型与冷静理性的表演成为观众热议的焦点。\n\n不少观众表示，小仓优子把法医这个职业的严谨与温度都演了出来。“她不靠呐喊，而是用眼神和细节让人信服。”有网友这样评价。\n\n剧组透露，为贴近角色，小仓优子提前跟随专业顾问学习了大量知识，从仪器的使用到术语的表达都力求准确。导演山田健一称赞她“把角色当成了一个真实存在的人来对待”。\n\n目前该剧热度仍在持续攀升，多个相关话题登上了讨论榜单，成为近期最受关注的口碑剧之一。',
  },
  {
    id: 5,
    title: '小仓优子参与公益短片拍摄，呼吁关注乡村儿童阅读',
    category: '活动资讯',
    date: '2026-07-25',
    views: 12480,
    thumbnail: 'https://readdy.ai/api/search-image?query=warm%20documentary%20photo%20of%20an%20elegant%20young%20East%20Asian%20actress%20reading%20a%20book%20with%20children%20in%20a%20sunlit%20rural%20classroom%2C%20soft%20natural%20light%2C%20golden%20and%20cream%20color%20tone%2C%20heartwarming%20atmosphere%2C%20high%20detail&width=800&height=500&seq=ogura-news-05&orientation=landscape',
    summary: '小仓优子近日参与公益短片拍摄，以实际行动呼吁社会关注乡村儿童的阅读状况。',
    content: '小仓优子近日参与了以“让每个孩子都有书读”为主题的公益短片拍摄。短片中，她走进乡村学校，与孩子们一起阅读、交流，画面温馨感人。\n\n谈及参与初衷，小仓优子表示自己对阅读有着深厚的感情。“小时候书是我认识世界的一扇窗，我希望更多孩子也能拥有这扇窗。”她说。\n\n拍摄间隙，小仓优子还与孩子们聊起了各自的梦想，并鼓励他们坚持阅读。工作人员透露，她主动延长了探访时间，只为多陪伴孩子们一会儿。\n\n该公益短片预计将在多个平台陆续上线，主办方也希望能借此号召更多人关注乡村儿童的成长。',
  },
  {
    id: 6,
    title: '《逆光飞翔》重映在即，小仓优子励志角色再引共鸣',
    category: '作品动态',
    date: '2026-07-10',
    views: 13920,
    thumbnail: 'https://readdy.ai/api/search-image?query=cinematic%20still%20of%20a%20determined%20young%20East%20Asian%20woman%20athlete%20running%20in%20a%20sunlit%20stadium%20with%20warm%20backlight%20and%20lens%20flare%2C%20energetic%20yellow%20and%20wine%20red%20color%20tone%2C%20inspiring%20sports%20drama%20aesthetic%2C%20high%20detail&width=800&height=500&seq=ogura-news-06&orientation=landscape',
    summary: '励志电影《逆光飞翔》宣布将于近期重映，小仓优子塑造的运动员形象再次引发观众共鸣。',
    content: '上映数年后，励志电影《逆光飞翔》宣布将于近期重返大银幕。消息一出，不少观众表示期待再次感受那份热血与感动。\n\n小仓优子在片中饰演田径选手宫本薰，从巅峰跌入低谷，又凭借顽强意志重新站上赛道。为诠释这个角色，她曾进行数月的体能训练，许多高难度的奔跑戏份均坚持亲自完成。\n\n“她演出了一个运动员的不甘与坚持。”有影评人如此评价。影片中“哪怕逆光，也要向前跑”的台词，更是成为许多观众心中的励志金句。\n\n此次重映还特别收录了幕后花絮，观众将有机会看到小仓优子在拍摄期间的点滴努力，感受角色背后的真实付出。',
  },
  {
    id: 7,
    title: '小仓优子生日粉丝见面会圆满举行，现场温情满满',
    category: '活动资讯',
    date: '2026-06-22',
    views: 21560,
    thumbnail: 'https://readdy.ai/api/search-image?query=warm%20event%20photo%20of%20an%20elegant%20young%20East%20Asian%20actress%20smiling%20on%20a%20stage%20decorated%20with%20soft%20lights%20and%20flowers%20during%20a%20fan%20meeting%2C%20golden%20and%20warm%20rose%20color%20tone%2C%20joyful%20intimate%20atmosphere%2C%20high%20detail&width=800&height=500&seq=ogura-news-07&orientation=landscape',
    summary: '小仓优子年度粉丝见面会如期举行，数百位粉丝到场，现场欢笑与泪水交织，气氛温馨感人。',
    content: '小仓优子年度粉丝见面会于近日圆满举行，数百位粉丝从各地赶来，为心中的偶像送上祝福。\n\n活动当天，小仓优子以一身简约清新的造型登场，一开场便引来阵阵欢呼。她与粉丝们一起回顾了过去一年的点滴，并分享了许多幕后的有趣故事。\n\n在互动环节中，几位幸运粉丝上台与偶像近距离交流，有人激动得红了眼眶。小仓优子一一认真回应，并为每位上台的粉丝准备了签名礼物。\n\n活动尾声，小仓优子动情地说：“是你们的支持让我一直走到现在，谢谢你们没有离开。”简单的一句话，让现场响起长时间的掌声。',
  },
  {
    id: 8,
    title: '幕后花絮：小仓优子为《雪国来信》苦练方言',
    category: '生活花絮',
    date: '2026-06-05',
    views: 10340,
    thumbnail: 'https://readdy.ai/api/search-image?query=candid%20behind%20the%20scenes%20photo%20of%20an%20elegant%20young%20East%20Asian%20actress%20studying%20a%20script%20in%20a%20snowy%20quiet%20village%20set%2C%20soft%20overcast%20light%2C%20cool%20white%20and%20warm%20tones%2C%20documentary%20photography%2C%20high%20detail&width=800&height=500&seq=ogura-news-08&orientation=landscape',
    summary: '电影《雪国来信》幕后花絮曝光，小仓优子为角色苦练方言，敬业态度令人印象深刻。',
    content: '电影《雪国来信》的幕后花絮近日曝光，其中小仓优子为角色苦练方言的片段引发关注。\n\n为还原片中北方小镇的真实氛围，小仓优子需要掌握一地方言。她为此专门请教了语言老师，并在休息时间反复练习录音。剧组工作人员回忆，她常常一个人对着剧本念上好几个钟头。\n\n“方言不仅是语言，它带着那片土地的温度。”小仓优子在花絮中这样说。她希望通过口音的变化，让角色更贴近真实。\n\n这份细致的努力最终呈现在银幕上，观众评价她的表演“连一呼一吸都带着雪国的气息”，敬业态度由此可见一斑。',
  },
  {
    id: 9,
    title: '小仓优子确认出演新剧《春日纪事》，题材聚焦女性成长',
    category: '作品动态',
    date: '2026-05-19',
    views: 15730,
    thumbnail: 'https://readdy.ai/api/search-image?query=cinematic%20concept%20photo%20of%20an%20elegant%20young%20East%20Asian%20woman%20in%20a%20light%20spring%20coat%20walking%20in%20a%20blossoming%20park%2C%20soft%20morning%20light%2C%20pale%20pink%20cream%20and%20gold%20color%20tone%2C%20warm%20hopeful%20atmosphere%2C%20high%20detail&width=800&height=500&seq=ogura-news-09&orientation=landscape',
    summary: '小仓优子正式确认出演新剧《春日纪事》，该剧以女性成长为主线，预计年底开机。',
    content: '小仓优子已正式确认出演新剧《春日纪事》。该剧聚焦当代女性的成长与抉择，是她继多部作品之后的又一新尝试。\n\n据介绍，《春日纪事》将以四季为时间轴，讲述女主角在不同人生阶段面对的挑战与蜕变。小仓优子将在剧中诠释一个从青涩到成熟、层次丰富的人物。\n\n谈及接下这个角色的原因，小仓优子表示，剧本中那些真实而细微的生活瞬间打动了她。“这不是一个完美的角色，但正因为不完美，才显得真实。”\n\n该剧预计于年底开机，主创团队表示将力求呈现一部温暖而有力量的作品，具体播出时间有待后续公布。',
  },
  {
    id: 10,
    title: '小仓优子写真集《暖光》发布，记录四季光影里的她',
    category: '生活花絮',
    date: '2026-04-28',
    views: 17650,
    thumbnail: 'https://readdy.ai/api/search-image?query=artistic%20portrait%20photo%20of%20an%20elegant%20young%20East%20Asian%20actress%20in%20soft%20natural%20sunlight%20with%20delicate%20film%20grain%2C%20warm%20cream%20and%20pale%20gold%20color%20tone%2C%20minimal%20elegant%20photography%2C%20high%20detail&width=800&height=500&seq=ogura-news-10&orientation=landscape',
    summary: '小仓优子全新写真集《暖光》正式发布，以四季为主题记录了她不同状态下的自然影像。',
    content: '小仓优子的全新写真集《暖光》近日正式发布。全书以四季更迭为线索，收录了大量她在自然光线下的影像。\n\n与以往偏正式的风格不同，这本写真集更注重真实与松弛。小仓优子坦言，拍摄过程更像是一次放松的旅行，“不用刻意摆姿势，就做最舒服的自己。”\n\n书中还附有她亲笔写下的一段随笔，分享了对光影与时间的感受。她写道：“每一束光都值得被记住，就像每一个当下。”\n\n写真集发布后反响热烈，多家书店表示首批库存迅速售罄，主办方已紧急加印以满足读者的需求。',
  },
  {
    id: 11,
    title: '小仓优子担任短片评审，鼓励年轻创作者大胆表达',
    category: '活动资讯',
    date: '2026-04-12',
    views: 9860,
    thumbnail: 'https://readdy.ai/api/search-image?query=professional%20event%20photo%20of%20an%20elegant%20young%20East%20Asian%20woman%20speaking%20on%20a%20panel%20in%20a%20modern%20auditorium%2C%20warm%20stage%20lighting%2C%20cream%20and%20wine%20red%20tone%2C%20confident%20atmosphere%2C%20high%20detail&width=800&height=500&seq=ogura-news-11&orientation=landscape',
    summary: '小仓优子受邀担任青年短片展评审，鼓励年轻创作者勇敢表达自己的想法。',
    content: '小仓优子近日受邀担任一场青年短片展的评审。活动期间，她观看了多部入围作品，并与年轻创作者进行了交流。\n\n在点评环节中，小仓优子表示自己更看重作品里的“真诚”。“技术可以慢慢练，但真诚的想法最难得。”她鼓励创作者不要害怕不完美，大胆去表达。\n\n不少参赛者表示，能够得到前辈的当面指点十分珍贵。有学生导演说：“她的话让我更有信心继续拍下去。”\n\n主办方表示，邀请小仓优子担任评审，正是希望借助她的经验与视角，为年轻一代提供更多鼓励与支持。',
  },
  {
    id: 12,
    title: '小仓优子经典作品回顾：那些让人难忘的荧幕瞬间',
    category: '媒体专访',
    date: '2026-03-20',
    views: 14230,
    thumbnail: 'https://readdy.ai/api/search-image?query=artistic%20film%20strip%20concept%20showing%20multiple%20warm%20cinematic%20moments%20of%20an%20elegant%20young%20East%20Asian%20actress%2C%20soft%20golden%20and%20wine%20red%20color%20tone%2C%20nostalgic%20retro%20atmosphere%2C%20high%20detail&width=800&height=500&seq=ogura-news-12&orientation=landscape',
    summary: '我们梳理了小仓优子历年来的代表作品，回望那些留在观众记忆里的经典荧幕瞬间。',
    content: '从初登荧幕的青涩，到如今的从容笃定，小仓优子用一部部作品记录了自己的成长，也陪伴了无数观众。\n\n回望她的演艺历程，《东京暮色》里独自走在街头的摄影师、《海边的信》中温柔坚韧的田中海音、《沉默的证人》里冷静专业的法医青山遥……每一个角色都带着独特的气质，却又能让人一眼认出属于她的那份真诚。\n\n有影迷评论说：“她的表演从来不张扬，却能悄悄走进你心里。”这或许正是小仓优子最动人的地方——她让角色活了起来，也让观众记住了她们。\n\n展望未来，还有更多故事等待被讲述。让我们一起期待，她接下来会带来怎样的惊喜。',
  },
];